module.exports = __webpack_public_path__ + "img/fb2.1f074af1.svg";